module Tapas.Bindings {
    export class LoadOnClick {
        public init(element: any, valueAccessor: () => any, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;

            var load = bindingContext.$root.load();

			ko.utils.registerEventHandler(element, "click", function () {
                load.active(true);
				load.text(valueAccessor());
            });
            
			$(window).unload(function () {
				load.active(false);
			});
        }
    }
    ko.bindingHandlers['loadOnClick'] = new LoadOnClick();
} 
